import { ref } from 'vue';
import axios from './useAxios';

export default function () {
    const link = ref(null);

    const getLink = async (hash) => {
        const res = await axios.get(`/links/hash/${hash}`);
        if (res.status === 200) {
            link.value = res.data;
        }
    };

    return {
        link,
        getLink,
    };
}
